import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { GroupsService } from '../../groups/groups.service';
import { AccessOptions } from '../../groups/models/group-detail.model';
import { SignInProposeService } from '../modals/signin-propose/signin-propose.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PublicAccessGuard  {
  constructor(private auth: AuthService, private router: Router, private groupsService: GroupsService, private signInProposeService: SignInProposeService) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.guard(state.url);
  }


  private guard(url) {
    // Check both logged in AND token not expired
    const isLoggedInWithValidToken = this.auth.isLoggedIn() && !this.auth.isIdenediTokenExpired();
    
    if (isLoggedInWithValidToken) {
      return of(true);
    }
    
    // If token is expired, logout to clear state
    if (this.auth.isLoggedIn() && this.auth.isIdenediTokenExpired()) {
      this.auth.logout(false);
    }

    // Without a group id we can't resolve login requirements; redirect to login.
    const groupDetails$ = this.groupsService.getGroupDetailsPublic(this.auth.idenediGroupId);
    if (!groupDetails$) {
      this.signInProposeService.setRedirectPath(url);
      this.router.navigate(['auth/login']);
      return of(false);
    }

    return groupDetails$.pipe(
      switchMap(group => {
        const loginRequired = group?.GroupSettings?.GroupApp?.LoginRequired ?? false;
        if (loginRequired) {
          this.signInProposeService.setRedirectPath(url)
          this.router.navigate(['auth/login']);
          return of(false);
        }
        return of(true);
      }),
      catchError(error => {
        console.error('PublicAccessGuard: API error:', error);
        // On API error, check loginRequired from environment or default to not required
        return of(true);
      })
    );
  }
}
